export const contactPhoneNumber = "22 120 18 80";
export const contactEmail = "pomoc@upacjenta.pl";
export const workingDaysHotlineHours = "6:00-20:00";
export const weekendHotlineHours = "8:00-15:00";
export const companyName = "House-Med SA";
export const fullCompanyAddress = "Kuklińskiego 17A, 30-720 Kraków";
